module.exports = __webpack_public_path__ + "img/20190916170507946.7010add8.jpg";